import {
  useModalContext,
  WSElement,
  WSIcon,
  WSModal
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useCMSWebflowEnterprise } from "../../../query/cms/queries";
import { useUserId } from "../../../query/hooks/helpers";
import { getCurrentEntepriseId } from "../../../query/platform/selectors";
import { useActivities } from "../../../query/users/queries";
import { useWSStore } from "../../../store";
import styles from "./LoomDemoModal.module.scss";

export const LOOM_DEMO_MODAL = "LOOM_DEMO_MODAL";

export const LoomDemoModal: React.FC = () => {
  const { closeModal } = useModalContext();

  const store = useWSStore();
  const userId = useUserId();

  const activityQuery = useActivities(userId);

  const enterpriseId = getCurrentEntepriseId(store, activityQuery.data);
  const enterpriseQuery = useCMSWebflowEnterprise(enterpriseId || "", {
    enabled: !!enterpriseId
  });
  const enterprise = enterpriseQuery.data;

  const { src: videoSrc, title: videoTitle } =
    enterprise && enterprise.exploreVideo && enterprise.exploreVideo.src
      ? enterprise.exploreVideo
      : {
          src: "https://www.loom.com/embed/f0e98f1f83d74ec396da6df1bbd2ad00",
          title: "Welcome to Wingspan"
        };
  return (
    <WSModal name={LOOM_DEMO_MODAL} className={styles.modal} size="L">
      <WSIcon
        name="close"
        className={styles.closeIcon}
        onClick={() => {
          closeModal(LOOM_DEMO_MODAL);
        }}
        size="M"
        color="grey600"
      />
      <WSElement className={styles.container}>
        <iframe
          title={videoTitle}
          src={videoSrc}
          frameBorder={0}
          allowFullScreen
          className={styles.video}
        ></iframe>
      </WSElement>
    </WSModal>
  );
};
